import { all, call, put, takeLatest } from 'redux-saga/effects'
import agent from 'agent'
import * as actions from 'redux/actions/admin.actions'

function* getUsersSaga(params) {
  try {
    const { filters } = params.payload
    const body = yield call(agent.Admin.getUsers, filters)
    yield put(actions.getAdminUsersSuccess(body.data, body.meta))
  } catch (error) {
    yield put(actions.getAdminUsersFailure(error))
  }
}

function* getDomainsSaga(params) {
  try {
    const { userId, filters } = params.payload
    const body = yield call(agent.Admin.getDomains, userId, filters)
    yield put(actions.getAdminUserDomainsSuccess(body.data))
  } catch (error) {
    yield put(actions.getAdminUserDomainsFailure(error))
  }
}

function* impersonateSaga(params) {
  try {
    const { userId } = params.payload
    const body = yield call(agent.Admin.getImpersonate, userId)
    const token = body.data.attributes.userToken
    const adminToken = localStorage.getItem('jwt')
    localStorage.setItem('admin-jwt', adminToken)
    localStorage.setItem('jwt', token)

    yield call(agent.setToken, token)
    window.location.pathname = '/dashboard'
  } catch (error) {
    yield put(actions.impersonateUserFailure(error))
  }
}

function* switchToAdminSaga() {
  const token = localStorage.getItem('admin-jwt')
  localStorage.removeItem('admin-jwt')
  localStorage.setItem('jwt', token)
  yield call(agent.setToken, token)
  window.location.pathname = '/admin/users'
}

export default function* accountSagas() {
  yield all([
    takeLatest(actions.getAdminUsers.type, getUsersSaga),
    takeLatest(actions.getAdminUserDomains.type, getDomainsSaga),
    takeLatest(actions.impersonateUser.type, impersonateSaga),
    takeLatest(actions.switchToAdmin.type, switchToAdminSaga)
  ])
}
